import { render, staticRenderFns } from "./rc-crm-notes-dialog.vue?vue&type=template&id=faea9cf4&scoped=true&"
import script from "./rc-crm-notes-dialog.vue?vue&type=script&lang=js&"
export * from "./rc-crm-notes-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faea9cf4",
  null
  
)

export default component.exports